
var toggleState = () => {
    $('[data-toggle-state]').on('click', function(e) {
        e.preventDefault();
        var $body = $('body'),
            element = $(this),
            className = element.data('toggleState'),
            // key = element.data('key'),
            $target = $body;

        if (className) {
            if ($target.hasClass(className)) {
                $target.removeClass(className);
            } else {
                $target.addClass(className);
            }

            if (Modernizr.mq('(max-width: 1280px)') || className === 'sidebar-overlay-open') {
                backDrops(className, element, $target);
            }
        }
    });
};

const switchMenuState = () => {
    var $body = $('body');
    var $html = $('html');
    if ($(window).width() < 992 && !$html.hasClass('backdrop-open')) {
        $body.removeClass('app_sidebar-menu-collapsed');
        $('#content_wrapper').removeClass('toggle-left toggle-right')
    } else if (!$html.hasClass('backdrop-open')){
        $body.removeClass('app_sidebar-left-open');
    }
};

const backDrops = (className, element, $target) => {
    var $body = $('body');
    var $html = $('html');
    if ($target.hasClass(className)) {
        if (className === 'expand' || className === 'app_sidebar-left-open') {
            $body.append(`<div class="backdrop ${className} top"></div>`);
        } else {
            $body.append(`<div class="backdrop ${className}"></div>`);
        }
        if(MaterialWrap.APP_TOUCH === true){
            $(`.${className}.backdrop`).hammer().bind('tap', function(e) {
                e.stopPropagation();
                element.trigger('click');
            });
        } else{
            $(`.${className}.backdrop`).on('click', function(e) {
                e.stopPropagation();
                element.trigger('click');
            });
        };
        if($('.backdrop').length > 0 && !$html.hasClass('backdrop-open')){
            $html.addClass('backdrop-open');
        }
    } else {
        $(`.${className}.backdrop`).fadeOut(250, function() {
            $(this).remove();
            if ($('.backdrop').length === 0){
                $html.removeClass('backdrop-open');
            }
        });
    }
};

export {
    toggleState,
    switchMenuState
}



// WEBPACK FOOTER //
// ./js/theme/layout.js